import create from 'zustand'
import produce from 'immer'

export const ModalStore = create((set) => ({
    modals: [],
    add: (item) => {
        set(
            produce((draft) => {
                draft.modals.unshift(item)
            }),
        )
    },
    remove: (number = 1) => {
        set(
            produce((draft) => {
                typeof number === 'number'
                    ? draft.modals.splice(0, number)
                    : draft.modals.splice(0, 1)
            }),
        )
    },
    skim: () => {
        set(
            produce((draft) => {
                draft.modals.splice(0, 1)
            }),
        )
    },
}))
